import Vue from "vue";

export const ticketPlay = {
    methods: {
        //TODO： 获取作业类型(字典)
        async getdictionaryList(name) {
            let res = await this.$http.get("/tenant/dictionary/content/list", {
                dictionaryName: name
            });
            return res.data || [];
        },
        //TODO: 获取生产计划列表
        async getConstructionList(obj) {
            let {pageNum, pageSize,workType } = obj;
            let res = await this.$http.get("/tenant/construction/list",{
                workType:workType??null,
                pageNum,
                pageSize,
            });
            return res || []
        },
        
        //TODO: 获取生产计划详细
        async getConstructionInfo(id) {
            let res = await this.$http.get(`/tenant/construction/${id}`);
            return res.data;
        },
        //TODO: 发送安全确认票
        async sendConstructionInfo(id) {
            let res = await this.$http.post(`/tenant/confirm/vote/construction/${id}`);
            if (res.code == 200) {
                this.$message({ message: res.msg, type: "success" });
            } else {
                this.$message.error(res.msg);
            }
            return res;
        },
        //TODO: 新增生产计划
        async addconstruction(obj) {
            let res = await this.$http.post("/tenant/construction", obj);
            if (res.code == 200) {
                this.$message({ message: res.msg, type: "success" });
            } else {
                this.$message.error(res.msg);
            }
            return res;
        },
        //TODO:修改生产计划
        async upConstructionInfo(obj) {
            let res = await this.$http.put("/tenant/construction", obj);
            if (res.code == 200) {
                this.$message({ message: res.msg, type: "success" });
            } else {
                this.$message.error(res.msg);
            }
            return res;
        },
          //TODO:删除生产计划
          async delConstructionInfo(id) {
            let res = await this.$http.delete(`/tenant/construction/${id}`);
            if (res.code == 200) {
                this.$message({ message: res.msg, type: "success" });
            } else {
                this.$message.error(res.msg);
            }
            return res;
        },
        //TODO：生产计划提交审批
        async submitConstructionInfo(obj) {
            let res = await this.$http.post(`/tenant/construction/submit`,{
                id:obj.id,
                approveId:obj.approveId
            });
            if (res.code == 200) {
                this.$message({ message: res.msg, type: "success" });
            } else {
                this.$message.error(res.msg);
            }
            return res;
        },

        //TODO: 获取生产计划值班类型
        async getConstructionType() {
            let res = await this.$http.get("/tenant/construction/workType/list");
        
            return res.data;
        },
        //TODO: 修改生产计划对应的值班类型
        async updateConstructionType(obj) {
            let res = await this.$http.put("/tenant/construction/workType",obj);
            if (res.code == 200) {
                this.$message.success(res.msg);
            } else {
                this.$message.error(res.msg);
            }
            return res;
        },
    },
};
